<ng-container *ngIf="!loading; else loadingShimmer">
  <store-order-item-list
    [showPricing]="showPricing"
    [orderItems]="orderItems"
    [partnerId]="partnerId"
    [marketId]="marketId"
  ></store-order-item-list>

  <ng-container *ngIf="showPricing">
    <div class="order-summary-divider">
      <mat-divider></mat-divider>
    </div>
    <store-order-summarized-totals [orderItems]="orderItems" [taxOptions]="taxOptions"></store-order-summarized-totals>
  </ng-container>

  <ng-container *ngIf="(duration || estimatedTotal) && showPricing">
    <hr />
    <store-contract-estimated-total
      [orderItems]="orderItems"
      [taxOptions]="taxOptions"
      [duration]="duration"
      [estimatedTotal]="estimatedTotal"
    ></store-contract-estimated-total>
  </ng-container>

  <ng-container *ngIf="showPricing">
    <store-order-summarized-charges
      [orderItems]="orderItems"
      [taxOptions]="taxOptions"
      [expanded]="expanded"
    ></store-order-summarized-charges>
  </ng-container>
</ng-container>
<ng-template #loadingShimmer>
  <div class="stencil-shimmer"></div>
  <div class="stencil-shimmer total-shimmer"></div>
</ng-template>
